module.exports = __webpack_public_path__ + "img/unavailable-product.35aa673.avif";